import { useMutation } from "@tanstack/react-query";
import http from "../../utils/http-common";

export function useUpdatePassword() {
  const updatePassword = async (passwordData: any) => {
    const response = await http.put("/user/password", passwordData);
    return response.data;
  };

  return useMutation({
    mutationFn: updatePassword,
  });
}
